<template>
    <!-- footer -->
	<div class="footer">
        <div class="footer-box clearfix">
            <div class="footer-slide fl">
                <p>中心地址：{{ profile.address }}</p>
                <p>{{ profile.copyright}}  <a target="_blank" :href="profile.recordQueryAddress">{{ profile.industryInformationRecordNum}}</a></p>
            </div>
            
            <div class="footer-slide fr">
                <p>联系电话：{{ profile.telephone }}</p>
                <p>联系邮箱：{{ profile.email }}</p>
            </div>
            
        </div>
        
    </div>
</template>
<style src="../../../static/css/studentindex.css" scoped></style>
<script>
export default {
    props:{
        profile:{//中心简介，包含邮箱联系方式等信息
            type:Object,
        },
    },
    data() {
		return {
            
		};
	},
    methods: {
        

    },
    created() {

    },
    mounted(){

    }
}
</script>




// WEBPACK FOOTER //
// src/views/common/RdFooter.vue